import React, { Component } from 'react';

import './footer.css';
import logo from './logo.png';

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <div className="footer-container">
                    <p>
                        <a href="https://www.grainger.com/content/safety-footwear-services">
                            GET HELP WITH YOUR FOOTWEAR PROGRAM
                        </a>
                        <span>|</span>
                        <a href="https://www.grainger.com/product-finder/shoe-selection-guide">
                            SHOP FOOTWEAR
                        </a>
                    </p>
                    <a href="https://www.grainger.com/">
                        <img src={logo} alt="Grainger Logo" />
                    </a>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js